import { Navigate } from 'react-router-dom';
import { useAuth } from '../core/customHooks/useAuth';
import { routes } from './constants';

export const PrivateRoute = ({ children }: { children: React.ReactElement | null }) => {
  const { isAuthenticated } = useAuth();
  return (isAuthenticated)
    ? children
    : <Navigate to={routes.login} />
}